export class Facet {

    constructor(
        public id: string,
        public label: string,
        public value = false,
        public group: string = '',
        public description?: string
    ) { }

    equal(facet: Facet): boolean {
        return facet === this || this.id === facet.id;
    }
}
